import { PersonsV3 } from '@frontend/api-person';

const CACHE_TIME = 1000 * 60 * 5; // 5 minutes

export const useGetPersonInfo = (personId: string, locationId: string) => {
  const { data: personInfo, isLoading: isLoadingPersonInfo } = PersonsV3.PersonQueries.useGetPersonLegacyQuery(
    { locationIds: [locationId], personId },
    {
      enabled: !!personId && !!locationId,
      cacheTime: CACHE_TIME,
      staleTime: CACHE_TIME,
      select: (data) => PersonsV3.PersonHelpers.convertPersonV3ToPerson(data),
    }
  );

  return { personInfo, isLoadingPersonInfo };
};
